<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.625 5.16016V12.3086C1.625 12.7437 1.7748 13.161 2.04146 13.4687C2.30811 13.7764 2.66977 13.9492 3.04688 13.9492H9.95312C10.3302 13.9492 10.6919 13.7764 10.9585 13.4687C11.2252 13.161 11.375 12.7437 11.375 12.3086V5.16016C11.375 5.12908 11.3643 5.09927 11.3453 5.07729C11.3262 5.05532 11.3004 5.04297 11.2734 5.04297H1.72656C1.69963 5.04297 1.67379 5.05532 1.65475 5.07729C1.6357 5.09927 1.625 5.12908 1.625 5.16016ZM8.4043 9.60244L6.78717 11.4681C6.71099 11.5559 6.6077 11.6053 6.5 11.6053C6.3923 11.6053 6.28901 11.5559 6.21283 11.4681L4.5957 9.60244C4.44107 9.42402 4.42686 9.13369 4.57412 8.94678C4.61109 8.89979 4.65594 8.86195 4.70596 8.83556C4.75597 8.80916 4.81012 8.79476 4.8651 8.79323C4.92008 8.79169 4.97476 8.80306 5.02583 8.82663C5.07689 8.85021 5.12328 8.8855 5.16217 8.93037L6.09375 10.005V6.93115C6.09375 6.67891 6.26184 6.4624 6.48045 6.4498C6.53538 6.44675 6.59027 6.4566 6.64181 6.47875C6.69334 6.50089 6.74044 6.53489 6.78025 6.57866C6.82006 6.62243 6.85176 6.67508 6.87342 6.7334C6.89507 6.79172 6.90624 6.85452 6.90625 6.91797V10.005L7.83783 8.93037C7.87672 8.8855 7.92311 8.85021 7.97417 8.82663C8.02524 8.80306 8.07992 8.79169 8.1349 8.79323C8.18988 8.79476 8.24403 8.80916 8.29404 8.83556C8.34406 8.86195 8.38891 8.89979 8.42588 8.94678C8.57314 9.1334 8.55893 9.42402 8.4043 9.60244Z"
      :fill="fill"
    />
    <path
      d="M11.375 1.76172H1.625C1.17627 1.76172 0.8125 2.18145 0.8125 2.69922V3.16797C0.8125 3.68574 1.17627 4.10547 1.625 4.10547H11.375C11.8237 4.10547 12.1875 3.68574 12.1875 3.16797V2.69922C12.1875 2.18145 11.8237 1.76172 11.375 1.76172Z"
      :fill="fill"
    />
    <rect
      x="3.25"
      y="5.82422"
      width="6.5"
      height="6.5625"
      :fill="fill"
    />
  </svg>

</template>

<script lang="ts" setup>
withDefaults(defineProps<{
  width?: string | number;
  height?: string | number;
  fill?: string
}>(), {
  width: 13,
  height: 16,
  fill: 'currentColor'
});
</script>